module.exports = __webpack_public_path__ + "fonts/sunflower-medium-webfont.woff";


//////////////////
// WEBPACK FOOTER
// ./src/common/fonts/Sunflower/sunflower-medium-webfont.woff
// module id = 3465
// module chunks = 0